<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("edit") }} {{ $tc("weekwiseContract", 2) }}
      </div>
      <router-link class="btn-blue" to="weekwise-contract"
        >{{ $tc("weekwiseContract", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form>
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-0">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  placeholder="."
                  type="text"
                  disabled
                  v-model="contract_weekwise_name"
                  name="weekwise_name"
                  id="weekwise_name"
                  v-validate="'required'"
                  v-b-tooltip.hover
                 :title="$t('contract_name_tooltip')" 
                />
                <!-- v-validate="{required: 'required', regex:/^[a-zA-Z0-9 ]*$/}" -->
                <label
                  >{{ $tc("weekwiseContract", 2) }} {{ $tc("name", 2) }}</label
                >
              </div>
              <!--Tooltip :title="$t('contract_name_tooltip')" /--->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('weekwise_name')">{{
                errors.first("weekwise_name")
              }}</span>
            </p>
          </div>

  <div class="col-lg-6 col-xl-8 align-self-center mb-0">
            <div class="d-flex align-items-center justify-content-end">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
             <label class="mb-0  ml-2">
                <b-form-checkbox
                  v-model="contracts_by_weekwise_is_active"
                  type="checkbox"
                  class="j-checkbox mb-0"
                  checked
                />
                
              </label>
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>

 <div class="col-lg-12 mb-2">
                      <h5 class="mb-0 heading">
                        {{ $t("contract") }} {{ $tc("details", 2) }}
                      </h5>
                    </div>
          <div
            class="col-12 mb-1 mt-1"
            v-for="(WeekwiseContract, WeekwiseContractKey) in WeekwiseContracts"
            :key="WeekwiseContractKey"
          >
            <div class="pt-3 pl-3 pr-3 pb-1  border rounded-10 back">
              <div class="row">
                <div class="col-lg-10 col-xl-11">
                  <div class="row">
                   
                    <!-- //Select Week -->
                    <div class="col-lg-6 col-xl-4 mb-0" style="height:55px">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <multiselect
                            v-model="WeekwiseContract.contract_week"
                            @select="onSelectWeek($event, WeekwiseContractKey)"
                            :placeholder="selectedWeek"
                            :options="
                              weekArray.filter(
                                w =>
                                  w.value == WeekwiseContractKey ||
                                  w.value == -1
                              )
                            "
                            label="name"
                            track-by="value"
                            name="select_week"
                            id="select_week"
                            :multiple="false"
                            v-validate
                            data-vv-rules="required"
                            data-vv-name="Week"
                            data-vv-value-path="value"
                            v-b-tooltip.hover
                            :title="$t('select_week_tooltip')"
                          ></multiselect>
                        </div>
                        <!--Tooltip :title="$t('select_week_tooltip')" /-->
                      </div>
                      <!-- <p
                        v-show="errors.has('Week')"
                        class="error_message"
                      >{{ errors.first('Week') }}</p>-->
                      <p class="error_message" style="margin-top:2px">
                        <span
                          v-if="
                            submitted &&
                              WeekwiseContract.contract_week.length == 0
                          "
                          >{{ selectedWeek }}</span
                        >
                      </p>
                    </div>
                    <!-- Select Week Ends -->

                    <!-- Select Contract -->
                    <div class="col-lg-6 col-xl-5 mb-0" style="height:55px">
                      <div class="d-flex align-items-center">
                        <div class="dropdown-curve-container">
                          <multiselect
                            v-model="WeekwiseContract.contract_id"
                            @select="
                              onSelectContract($event, WeekwiseContractKey)
                            "
                            :placeholder="selectedContract"
                            :options="ms_contracts"
                            label="contract_name"
                            track-by="contract_id"
                            name="select_contract"
                            id="select_contract"
                            :multiple="false"
                            v-b-tooltip.hover
                            :title="$t('select_contract_tooltip')" 

                          ></multiselect>
                          <!-- v-validate
                            data-vv-rules="required"
                            data-vv-name="Contract Name"
                          data-vv-value-path="contract_id"-->
                        </div>
                        <!--Tooltip :title="$t('select_contract_tooltip')" /-->
                      </div>
                      <p class="error_message" style="margin-top:2px">
                        <span
                          v-if="
                            submitted &&
                              WeekwiseContract.contract_id.length == 0
                          "
                          >{{ selectedContract }}</span
                        >
                      </p>
                      <!-- <p
                        v-show="errors.has('Contract Name')"
                        class="error_message"
                      >{{ errors.first('Contract Name') }}</p>-->
                    </div>
                    <!-- Select Contract Ends -->
                  </div>
                </div>
                <div
                  class="col-lg-2 col-xl-1 border-left d-flex justify-content-center align-items-center"
                >
                  <button
                    v-if="WeekwiseContractKey === 0"
                    @click.stop.prevent="addWeekWiseContract"
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/plus.svg"
                      height="30"
                      width="30"
                    />
                  </button>
                  <!-- <button
                    v-if="WeekwiseContractKey === 0 && WeekwiseContractKey.length !== 1"
                    @click.stop.prevent="removeWeekWiseContract(WeekwiseContractKey)"
                    class="btn-transparent"
                  >
                    <img src="@/assets/img/icons/minus.svg" height="30" width="30" />
                  </button>-->
                  <button
                    v-if="
                      WeekwiseContractKey !== 0 &&
                        WeekwiseContractKey == WeekwiseContracts.length - 1
                    "
                    @click.stop.prevent="
                      removeWeekWiseContract(WeekwiseContractKey)
                    "
                    class="btn-transparent"
                  >
                    <img
                      src="@/assets/img/icons/minus.svg"
                      height="30"
                      width="30"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>

        

          <div class="col-12 text-center pt-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="onFinalSubmit"
              class="btn-blue"
            >
              Update
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import DistributorService from "@/services/DistributorService";

export default {
  data() {
    return {
      submitted: false,
      btenable: false,
      contract_weekwise_name: null,
      cbw_common_code: null,
      contracts_by_weekwise_is_active: true,
      ms_contracts: [],
      weekArray: [
        {
          name: "Week 0",
          value: 0
        },
        {
          name: "Week 1",
          value: 1
        },
        {
          name: "Week 2",
          value: 2
        },
        {
          name: "Week 3",
          value: 3
        },
        {
          name: "Week 4",
          value: 4
        },
        {
          name: "Week 5",
          value: 5
        },
        {
          name: "Thereafter",
          value: -1
        }
      ],
      selectedContract: "Contract Type.",
      selectedWeek: "Week.",
      WeekwiseContracts: [
        // {
        //   contract_week: "",
        //   contract_id: ""
        // }
      ],
      removedWeekwiseContracts: []
    };
  },
  mounted() {
    this.cbw_common_code = this.$route.query.cbw_common_code;
    if (this.cbw_common_code) {
      this.getActiveContracts();
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getContractWeekwiseDetails: function() {
      let payload = {
        cbw_common_code: this.cbw_common_code
      };
      DistributorService.GetSingleContractByWeekWiseDetails(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.contract_weekwise_name =
              data.Records[0].contract_weekwise_name;
            data.Records.map(x => {
              let weekArray = this.weekArray.filter(y => {
                return x.contract_week == y.value;
              });
              let contractArray = this.ms_contracts.filter(y => {
                return x.contract_id == y.contract_id;
              });
              this.WeekwiseContracts.push({
                cbw_id: x.cbw_id,
                contract_week: weekArray[0],
                contract_id: contractArray[0]
              });
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    getActiveContracts: function() {
      let payload = {
        tableName: "ms_contracts",
        contract_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.ms_contracts = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(async () => {
          await this.getContractWeekwiseDetails();
        }); //message
    },
    addWeekWiseContract: function() {
      console.log("this.WeekwiseContracts", this.WeekwiseContracts);
      if (
        this.WeekwiseContracts.findIndex(w => w.contract_week.value == -1) !==
        -1
      ) {
        this.$toasted.show(
          "You have already added Thereafter. Cannot add any more weeks"
        );
        return;
      } else {
        this.WeekwiseContracts.push({
          contract_week: "",
          contract_id: ""
        });
      }
    },
    removeWeekWiseContract: function(index) {
      this.removedWeekwiseContracts.push(this.WeekwiseContracts[index]);
      this.WeekwiseContracts.splice(index, 1);
      console.log(
        "this.removedWeekwiseContracts :>> ",
        this.removedWeekwiseContracts
      );
    },
    onSelectWeek: function(event, index) {
      this.WeekwiseContracts[index].contract_week = event.value;

      if (event.value === -1 && this.WeekwiseContracts.length - 1 !== index) {
        this.WeekwiseContracts = this.WeekwiseContracts.slice(0, index + 1);
      }

      // let _index = this.weekArray.findIndex(x => {
      //   return x.value == event.value;
      // });
      // this.weekArray.splice(_index, 1);
    },
    onSelectContract: function(event, index) {
      this.WeekwiseContracts[index].contract_id = event.contract_id;
    },
    ContractDetailsValidation: function() {
      let count = 0;
      this.WeekwiseContracts.map(x => {
        if (x.contract_week.length == 0 || x.contract_id.length == 0) {
          count++;
        }
      });

      const thereAfterIndex = this.WeekwiseContracts.findIndex(
        w => w.contract_week.value == -1
      );

      if (thereAfterIndex === -1) {
        this.$toasted.show("Please add a 'ThereAfter' contract");
      }

      if (count > 0 || thereAfterIndex === -1) {
        return true;
      } else {
        return false;
      }
    },
    onFinalSubmit: function() {
      this.submitted = true;
      // let thereAfterArray = this.WeekwiseContracts.filter(x => {
      //   return x.contract_week.value == -1;
      // });
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.ContractDetailsValidation()) {
            return;
          }

          this.btenable = true;
          let payload = {
            contract_weekwise_name: this.contract_weekwise_name,
            contracts_by_weekwise_is_active: this
              .contracts_by_weekwise_is_active,
            WeekwiseContracts: this.WeekwiseContracts,
            removedWeekwiseContracts: this.removedWeekwiseContracts,
            cbw_common_code: this.cbw_common_code
          };
          DistributorService.UpdateMasterContractByWeekWise(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;
              if (data && data.status) {
                this.$validator.reset();
                this.$router.push({
                  path: "weekwise-contract"
                });
                this.$toasted.show(data.message);
              } else {
                if (data.error && data.error.sqlMessage) {
                  this.$toasted.show(data.error.sqlMessage);
                } else {
                  this.$toasted.show(data.message);
                }
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>
<style>
.back{
  background-color: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/WeekWiseContractComponents/editWeekwiseContract.vue